import { useState } from "react";
import useEvaApi, { EvaApiCall } from "../../../../../hooks/useEvaApi";
import ManualSignOutPageView from "./ManualSignoutPageView";
import useCustomEffect from "../../../../../hooks/useCustomEffect";
import { useFrontofficeContext } from "../../../../../context/FrontofficeContext";
import { useParameterContext } from "../../../../../context/ParameterContext";

function ManualSignOutPage() {
  const callEvaApi = useEvaApi();
  const { filterVisitorsBySearch, terminal, updatePage } =
    useFrontofficeContext();
  const { getParameter } = useParameterContext();
  const [visitors, setVisitors] = useState([]);
  const [search, setSearch] = useState("");

  const minSearchLength = parseInt(
    getParameter("name.search.min.chars")?.value ?? 3,
  );
  const filteredVisitors =
    search.length >= minSearchLength
      ? filterVisitorsBySearch(search, visitors)
      : [];
  const selectedVisitor =
    filteredVisitors.length === 1 ? filteredVisitors[0] : null;

  /**
   * UseEffect for automatically fetching the visitors
   */
  useCustomEffect(() => {
    fetchVisitors();
  });

  /**
   * This method will fetch the visitors from the API
   */
  async function fetchVisitors() {
    await callEvaApi(
      new EvaApiCall("visitors")
        .setLoadingGroup("sign_out_fetch")
        .setParams({
          with_visitor_fields_data: true,
          with_visitor_question_answers_data: true,
          with_visitor_houserules_data: true,
          with_visitor_visitor_type_data: true,
          with_visitor_external_ids_data: true,
          where: [
            {
              column: "status",
              values: ["signed_in"],
            },
            {
              column: "visitor_type_id",
              values: [
                {
                  value: terminal?.visitor_types?.map(
                    (tvt) => tvt.visitor_type.id,
                  ),
                  operator: "in",
                },
              ],
            },
          ],
        })
        .setOnSuccess((response) => {
          setVisitors(response.data.data.records);
        }),
    );
  }

  /**
   * This method will handle the search change event
   * @param {event} e
   */
  function onSearchChange(e) {
    setSearch(e.target.value);
  }

  /**
   * This method will continue to the sign out of the selected visitor, when the search matches exactly one visitor
   */
  function onSignOut() {
    if (!selectedVisitor) {
      return;
    }

    updatePage("visitor_type", {
      visitor: selectedVisitor,
      visitorType: terminal?.visitor_types?.find(
        (tvt) => tvt.visitor_type.id === selectedVisitor.visitor_type.id,
      )?.visitor_type,
      signIn: false,
    });
  }

  return (
    <ManualSignOutPageView
      search={search}
      selectedVisitor={selectedVisitor}
      onSearchChange={onSearchChange}
      onSignOut={onSignOut}
    />
  );
}

export default ManualSignOutPage;
